import './GenericList.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NoData } from '@ui/NoData';
import React from 'react';
import { When } from 'react-if';

const defaultClassName = 'generic-list';

export interface GenericListProps<T> {
    className?: string;
	empty?: React.ReactNode;
	items: Array<T>;
    loading: boolean;
    renderItem: (item: T, index: number) => JSX.Element;
	title?: string;
}

function GenericListInner<T>({
	className,
	empty = <NoData />,
	items,
	loading,
	renderItem,
	title
}: GenericListProps<T>, ref: React.ForwardedRef<HTMLDivElement>) {
	const classes = className ? classNames(defaultClassName, className) : defaultClassName;

	return (
		<>
			{ title && <div className='periscope-list-title'>{ title }</div> }
			<div
				className={ classes }
				ref={ ref }>
				<LoadingSpinner spinning={ loading }>
					<When condition={ !loading && items.length === 0 }>
						{ empty }
					</When>
					{ items?.map(renderItem) }
				</LoadingSpinner>
			</div>
		</>
	);
}

export const GenericList = React.forwardRef(GenericListInner);
